"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _misc = _interopRequireDefault(require("../../helpers/misc"));

var _jsonrpc = require("../jsonrpc");

var _ethereumjsUtil = _interopRequireDefault(require("ethereumjs-util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, res, next) {
    var payload, parts, recovered, addressBuffer;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload;

            if (!(payload.method !== 'personal_ecRecover')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", next());

          case 3:
            if (payload.params.length < 2) {
              res((0, _jsonrpc.toError)(payload.id, "personal_ecRecover expects 2 parameters.  Received ".concat(payload.params.length, " ")));
            }

            parts = _ethereumjsUtil.default.fromRpcSig(payload.params[1]);

            if (!parts) {
              res((0, _jsonrpc.toError)(payload.id, 'Invalid signature supplied to personal_ecRecover'));
            }

            recovered = _ethereumjsUtil.default.ecrecover(_ethereumjsUtil.default.hashPersonalMessage(_misc.default.toBuffer(payload.params[0])), parts.v, parts.r, parts.s);
            addressBuffer = _ethereumjsUtil.default.pubToAddress(recovered);
            res(null, (0, _jsonrpc.toPayload)(payload.id, '0x' + addressBuffer.toString('hex')));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = _default;